import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import { IEventEdit } from '@/enitites/event'
// eslint-disable-next-line import/no-cycle
import EventTotalSection from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventTotalSection.vue'
import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import EventGeneralInfo from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventGeneralInfo.vue'
import EventDateTime from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventDateTime.vue'
import EventBattles from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventBattles.vue'
import EventDisplayMode from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventDisplayMode.vue'
import EventPaymentSystem from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventPaymentSystem.vue'
import EventOwnPaymentMethod from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventOwnPaymentMethod.vue'
import EventBankAccount from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventBankAccount.vue'
import EventTicketsDiscounts from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventTicketsDiscounts.vue'
import EventRefundPolicy from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventRefundPolicy.vue'
import EventGuestList from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal/EventGuestList.vue'
import { useEventPublishMutation, useEventDeleteMutation } from '@/enitites/event/api/queries'
import { ModalWrapper } from '@/shared/ui/modals'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventTotal',
  props: {
    eventData: null
  },
  emits: ["back", "next", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'back'): void
  (e: 'next'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};





const { mutate, isPending, error } = useEventPublishMutation()
const { mutate: deleteEvent, isPending: isDeletePending } = useEventDeleteMutation()
const router = useRouter()

const isShowDeleteModal = ref(false)

const handleNext = () => {
  if (props.eventData.status === 'published') {
    emit('next')
    return
  }

  mutate(props.eventData.id, {
    onSuccess: () => {
      emit('next')
    },
  })
}

const handleDeleteEvent = () => {
  if (isDeletePending.value) return

  deleteEvent(props.eventData.id, {
    onSuccess: () => {
      router.push({ name: 'EventsPage' })
    },
  })
}

return { __sfc: true,props, emit, mutate, isPending, error, deleteEvent, isDeletePending, router, isShowDeleteModal, handleNext, handleDeleteEvent, EventTotalSection, EventEditActionButtons, EventGeneralInfo, EventDateTime, EventBattles, EventDisplayMode, EventPaymentSystem, EventOwnPaymentMethod, EventBankAccount, EventTicketsDiscounts, EventRefundPolicy, EventGuestList, ModalWrapper }
}

})